import { AppRouteHelper } from '@shared/helpers/app-route.helper';
import { PermissionGuard } from '@app/guards/permission.guard';
import { ShellComponent } from '@app/shell/shell.component';
import { Route, Routes } from '@angular/router';

export class Shell {
	static childRoutes(routes: Routes): Route {
		return {
			path: AppRouteHelper.shellPrefix,
			component: ShellComponent,
			canActivateChild: [PermissionGuard],
			children: routes,
		};
	}
}
